import { DemoOrganization } from './types';

export const DEMO_ORGANIZATION_INITIAL_DATA: DemoOrganization[] = [
  {
    id: 'float16-inc',
    name: 'Float16 Inc.',
    role: 'admin',
    quota: {
      h200: { total: 8, used: 4 },
      a100: { total: 16, used: 4 },
      l4: { total: 32, used: 8 },
    },
    createdAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'personal-org',
    name: 'Personal',
    role: 'owner',
    quota: {
      h200: { total: 1, used: 0 },
      a100: { total: 2, used: 1 },
      l4: { total: 4, used: 2 },
    },
    createdAt: '2024-01-01T00:00:00Z',
  },
];
